import Header from "../components/common/Header";
import WordCard from "../components/home/WordCard";
import Footer from "../components/common/Footer";
import SubscribeModal from "../components/subscription/SubscribeModal";
import AddWordModal from "../components/home/AddWordModal";
import { useContext, useState } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import { SubscribeModalContext } from "../providers/SubscribeModalProvider";

function App() {
  const { open } = useContext(SubscribeModalContext);
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  return (
    <Box sx={{ minHeight: "100vh", backgroundColor: "#f1f5f9", display: "flex", flexDirection: "column" }}>
      <Box sx={{ width: "100%", position: "sticky", top: "0", zIndex: 100 }}>
        <Header />
      </Box>

      <Modal
        // 課金をスタートさせるときに、open={open}へ変更する
        open={false}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div>
          <SubscribeModal />
        </div>
      </Modal>

      <Box sx={{ maxWidth: 720, mx: "auto", px: 2, pt: 4, pb: 2, flex: 1, width: "100%" }}>
        {/* Page heading */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 4 }}>
          <Box
            sx={{
              width: 44,
              height: 44,
              borderRadius: "12px",
              background: "linear-gradient(135deg, #4338ca, #6366f1)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 4px 12px rgba(99,102,241,0.4)",
            }}
          >
            <MenuBookIcon sx={{ color: "white", fontSize: 22 }} />
          </Box>
          <Box>
            <Typography
              sx={{
                fontWeight: 700,
                fontSize: "1.4rem",
                color: "#1e293b",
                lineHeight: 1.2,
              }}
            >
              My Words
            </Typography>
            <Typography sx={{ fontSize: "0.8rem", color: "#94a3b8" }}>
              学習中の単語リスト
            </Typography>
          </Box>
        </Box>

        <WordCard refreshKey={refreshKey} />
      </Box>

      <Footer />

      <Fab
        onClick={() => setAddModalOpen(true)}
        sx={{
          position: "fixed",
          bottom: 28,
          right: 24,
          background: "linear-gradient(135deg, #4338ca, #6366f1)",
          color: "white",
          boxShadow: "0 6px 20px rgba(99,102,241,0.45)",
          "&:hover": {
            background: "linear-gradient(135deg, #3730a3, #4f46e5)",
          },
        }}
      >
        <AddIcon />
      </Fab>

      <AddWordModal
        open={addModalOpen}
        onClose={() => setAddModalOpen(false)}
        onAdded={() => setRefreshKey((k) => k + 1)}
      />
    </Box>
  );
}

export default App;
